<template>
	<div class="h5-table">
		<div class="title-font">
			历年放电收益如下：
			<div class="unit">(单位/万元)</div>
		</div>
		<a-table
			:data-source="yearProfitInfosTableDatas"
			:pagination="false"
			bordered
		>
			<!-- 插槽写法 -->
			<a-table-column key="year" data-index="year">
				<template #title>
					<div style="width: 30px" class="cell-title">年份</div>
				</template>
			</a-table-column>
			<a-table-column key="dischargeProfit" data-index="dischargeProfit">
				<template #title>
					<div style="min-width: 55px" class="cell-title">
						放电收益
					</div>
				</template>
			</a-table-column>
			<a-table-column key="sharingRatio" data-index="sharingRatio">
				<template #title>
					<div class="cell-title">投资方分成比例</div>
				</template>
			</a-table-column>
			<a-table-column key="investorProfit" data-index="investorProfit">
				<template #title>
					<div class="cell-title">投资方分成收益</div>
				</template>
			</a-table-column>
			<a-table-column key="ownerProfit" data-index="ownerProfit">
				<template #title>
					<div class="cell-title">业主分成收益</div>
				</template>
			</a-table-column>
		</a-table>

		<div style="margin-top: 24px" class="title-font m4">
			投资方现金流表如下：
            <div class="unit">(单位/万元)</div>
		</div>
		<div class="title-font">
			累计现金流在第
			<div class="year">{{ year || "-" }}</div>
			年回正
		</div>
		<a-table
			:data-source="InvestorCashFlowsTableData"
			:pagination="false"
			bordered
		>
			<!-- 插槽写法 -->
			<a-table-column key="year" data-index="year">
				<template #title>
					<div style="width: 30px" class="cell-title">年份</div>
				</template>
			</a-table-column>
			<a-table-column key="dischargeProfit" data-index="dischargeProfit">
				<template #title>
					<div style="min-width: 55px" class="cell-title">
						放电收入
					</div>
				</template>
			</a-table-column>
			<a-table-column key="operationOutput" data-index="operationOutput">
				<template #title>
					<div class="cell-title">运营支出</div>
				</template>
			</a-table-column>
			<a-table-column
				v-if="hasTaxInfo"
				key="taxOutput"
				data-index="taxOutput"
			>
				<template #title>
					<div class="cell-title">税费支出</div>
				</template>
			</a-table-column>
			<a-table-column key="cashFlow" data-index="cashFlow">
				<template #title>
					<div class="cell-title">净现金流</div>
				</template>
			</a-table-column>
			<a-table-column key="totalCashFlow" data-index="totalCashFlow">
				<template #title>
					<div class="cell-title">累计净现金流</div>
				</template>
			</a-table-column>
		</a-table>
	</div>
</template>

<script setup>
	import { ref, defineProps, watch } from "vue";
	import { toFixed } from "@/plugins/index.js";
	import { makeTotalData } from "../../../../../plugin";

	const props = defineProps({
		yearProfitInfos: {
			type: Object,
			default: () => {
				return null;
			}
		},
		investorCashFlows: {
			type: Object,
			default: () => {
				return null;
			}
		},
		hasTax: {
			type: Boolean,
			default: () => {
				return false;
			}
		}
	});

	const yearProfitInfosTableDatas = ref([]);

	const InvestorCashFlowsTableData = ref([]);

	const hasTaxInfo = ref(false);

	const year = ref(null);

	// 生成数据
	const makeYearProfitInfosTableData = (lists = []) => {
		let arr = [];
		lists.map((el, index) => {
			arr.push({
				year: index + 1,
				dischargeProfit: toFixed(el.dischargeProfit / 10000),
				sharingRatio: `${toFixed(el.sharingRatio)}%`,
				investorProfit: toFixed(el.investorProfit / 10000),
				ownerProfit: toFixed(el.ownerProfit / 10000)
			});
		});
		let totalRow = makeTotalData(
			lists,
			["dischargeProfit", "investorProfit", "ownerProfit"],
			["sharingRatio"]
		);
		yearProfitInfosTableDatas.value = [...arr, totalRow];
	};

	// 生成数据
	const makeInvestorCashFlowsTableData = (lists = []) => {
		let arr = [];
		lists.map((el, index) => {
			arr.push({
				year: index,
				dischargeProfit: toFixed(el.dischargeProfit / 10000),
				operationOutput: toFixed(el.operationOutput / 10000),
				taxOutput: toFixed(el.taxOutput / 10000),
				cashFlow: toFixed(el.cashFlow / 10000),
				totalCashFlow: toFixed(el.totalCashFlow / 10000)
			});

			if (el.totalCashFlow > 0 && year.value == null) {
				year.value = index;
			}
		});

		let totalRow = makeTotalData(
			lists,
			["dischargeProfit", "operationOutput", "taxOutput"],
			["cashFlow", "totalCashFlow"]
		);
		InvestorCashFlowsTableData.value = [...arr, totalRow];
	};

	watch(
		() => props.yearProfitInfos,
		newVal => {
			console.log(newVal);
			if (newVal) {
				// 生成数据
				makeYearProfitInfosTableData(newVal);
			}
		},
		{ immediate: true, deep: true }
	);

	watch(
		() => props.investorCashFlows,
		newVal => {
			console.log(newVal);
			if (newVal) {
				// 生成数据
				makeInvestorCashFlowsTableData(newVal);
			}
		},
		{ immediate: true, deep: true }
	);

	// 监听添加税列信息
	watch(
		() => props.hasTax,
		newVal => {
			hasTaxInfo.value = newVal;
		},
		{ immediate: true, deep: true }
	);
</script>

<style lang="less" scoped>
	.h5-table {
		margin: 24px 0px;
		.title-font {
			height: 20px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			font-size: 14px;
			color: #000000d9;
			letter-spacing: 0;
			text-align: justify;
			line-height: 20px;
			margin-bottom: 8px;
			display: flex;
			align-items: center;

			.year {
				color: #0058fc;
			}

			.unit {
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #000000a6;
				letter-spacing: 0;
			}
		}
	.m4 {
		margin-bottom: 4px;
	}
		.cell-title {
			opacity: 0.85;
			font-family: PingFangSC-Medium;
			font-weight: 600;
			font-size: 12px;
		}
	}
	::v-deep .ant-table-cell {
		font-size: 12px;
		padding: 8px !important;
		text-align: center !important;
	}
</style>
